import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';
import imageLoader from '../images/email-loader.gif'

class ContactComponent extends Component {

      constructor(props){
            super(props);
            this.state={
                  fullname:'',
                  email:'',
                  message:''
            };
      }

      componentDidMount(){
            $('.email-loader').hide()
            $("#message").focus(function(){
                  $("#label-message").addClass("label-textarea")
            })
            $("#message").blur(function(){
                  $("#label-message").removeClass("label-textarea")
            })

            $('.popupbox').hide()
      }


      onChange = event => {
            this.setState({ [event.target.name]: event.target.value });
          };

      onSubmit=e=>{
            let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if(this.state.fullname === '' || this.state.email === '' || this.state.message === ''){
                  alert('Please Fill all the details')
            }
            else if(!regex.test(this.state.email)){
                  alert('Please Enter valid email address')
                  return
            }
            else{
                  $('.email-loader').show()
            
      axios.post('/send-email',{
            fullname:this.state.fullname,
            email:this.state.email,
            message:this.state.message
      })
      .then(data =>{
            if(data.status === 200){
            $('.email-loader').fadeOut(1000)
            $('.alert-success').fadeIn(3000)
            this.setState({
                  fullname:'',
                  email:'',
                  message:''
            })
            }
            else{
                  $('.email-loader').fadeOut(1000)
                  $('.alert-danger').fadeIn(3000)    
                  this.setState({
                        fullname:'',
                        email:'',
                        message:''
                  }) 
            }
      })
      .catch(err=>{
            $('.email-loader').fadeOut(1000)
            $('.alert-danger').fadeIn(3000)    
            this.setState({
                  fullname:'',
                  email:'',
                  message:''
            })        
      })
}
      }

      
      render() {
            return (
                  <div className="contactform-container" id="contact">
                        <div className="container">   
                       <div className="d-flex">
                              <h1 id="contactform-heading">LET'S CREATE SOMETHING GREAT</h1>      
                       </div>
                       <div className="d-flex w-100 get-in-touch">
                              <p className="text-white text-left">If you wanna get in touch, talk to me about a project collaboration or just say hi, fill up the awesome form below or send an email to <a href="mailto:hardychugh34@gmail.com?Subject=Hello Hardik!!" rel="noopener noreferrer" target="_blank"> hardychugh34@gmail.com </a> and ~let's talk.</p>      
                       </div> 
                       <div className="form-container">
                             <div >    
                            <div className="field">
                                 <input type="text" name="fullname" id="fullname" maxLength="50"  placeholder="Enter Your Name" onChange={this.onChange} value={this.state.fullname}  />
                                 <label htmlFor="fullname">Name</label>
                            </div>
                            <div className="field">
                                 <input type="email" name="email" id="email" placeholder="Enter Your Email"  onChange={this.onChange}  value={this.state.email} />
                                 <label htmlFor="email">Email</label>
                            </div>
                            <div className="field">
                                 <textarea type="text" spellCheck="true" rows="7" name="message" id="message"  onChange={this.onChange} value={this.state.message}  ></textarea>
                                 <label htmlFor="message" id="label-message">Message</label>
                            </div>
                            <input type="button" className="jelly mb-4" value="Send" onClick={this.onSubmit}  />
                            <img src={imageLoader}  alt="email loader" className="email-loader" />
                             </div>
                             </div>
                      
                     </div>
                     <div className="alert-success popupbox" >
                           <span>
                           Your Message has been sent successfully. Check your email for more information.</span>
                              </div>
                              <div className="alert-danger popupbox" >
                           <span>
                                 Something went wrong, Please Try again!!
                           </span>
                              </div>
                    </div>
            );
      }
}

export default ContactComponent;


